import { removeRecordFromRegistry } from '../feature-metadata';

export const removeEnvelope = (
    envelopeKey: string,
    metadataKey: string,
    storage: Storage
) => {
    storage.removeItem(envelopeKey);
    removeRecordFromRegistry(metadataKey, envelopeKey, storage);
};
